import React from 'react';
import HeroSection from '../components/HeroSection';
import AboutStephane from '../components/AboutStephane';
import ServicesSection from '../components/ServicesSection';
import ContactSection from '../components/ContactSection';
import { Helmet } from "react-helmet-async";
import ObjetsPage from "../components/ObjetsPage";
import debarrassageImage from '../images/avant-apres-debarras.PNG';

function DetailsSection() {
    return (
        <section className="about-stephane">
            <div className="about-container">
                <h3>Débarras et Succession</h3>
                <p>
                    En tant qu’antiquaire expert, je ne me contente pas uniquement de racheter des objets anciens et des antiquités. Je propose également un service complet de débarras de maison, que ce soit après un décès, un départ à la retraite ou toute autre situation nécessitant de vider un lieu.
                </p>
                <div className="image-container">
                    <img src={debarrassageImage} alt="Avant et après un débarras" />
                </div>
                <p>
                    Ce service peut, dans de nombreux cas, être entièrement gratuit si des antiquités ou objets de valeur sont récupérés. En évaluant et valorisant correctement les biens, je vous offre la possibilité de réduire, voire d’annuler les frais de débarras. Mon objectif est de vous accompagner avec professionnalisme tout en vous permettant de tirer le meilleur parti des objets présents.
                </p>
                <p>
                    Mon objectif est de vous accompagner dans cette démarche avec professionnalisme, tout en vous permettant de récupérer une partie de la valeur des biens que vous souhaitez vendre ou éliminer.
                </p>
                <a href="tel:0658084516" className="hero-button yellow-bg">
                    06 58 08 45 16
                </a>
            </div>

            <style jsx>{`
                .about-stephane {
                    padding: 50px 20px;
                    background-color: #f5f5f5;
                    color: #333;
                    text-align: center;
                }

                .about-container {
                    max-width: 800px;
                    margin: auto;
                }

                h3 {
                    font-size: 1.8rem;
                    margin-bottom: 10px;
                    color: #20453d;
                }

                p {
                    font-size: 1.2rem;
                    line-height: 1.8;
                    margin-bottom: 20px;
                }

                .image-container {
                    margin: 20px 0;
                }

                .image-container img {
                    max-width: 70%;
                    height: auto;
                    border-radius: 10px;
                }

                .hero-button {
                    background-color: #ffd700;
                    color: #000;
                    padding: 10px 20px;
                    text-decoration: none;
                    border-radius: 5px;
                    font-weight: bold;
                }

                @media (max-width: 768px) {
                    p {
                        font-size: 1rem;
                    }

                    .image-container img {
                        margin: auto;
                        display: block;
                        width: 100%;
                    }
                }
            `}</style>
        </section>
    );
}

function HomePage() {
    return (
        <div>
            <Helmet>
                <title>Antiquaire Expert à Paris | Antiquités Stéphane Weinrich</title>
                <meta name="description" content="Antiquaire expert à Paris, Stéphane Weinrich vous propose une collection d'antiquités rares et précieuses, ainsi que des services de restauration et d'expertise." />
            </Helmet>
            <HeroSection />
            <AboutStephane />
            <ObjetsPage />
            <DetailsSection />
            <ServicesSection />
            <ContactSection />
        </div>
    );
}

export default HomePage;
